import React, { useState } from 'react';
import { Label } from 'reactstrap';
import { ModalHeader, ModalBody } from 'reactstrap';
import _ from 'lodash';
import _debounce from 'lodash.debounce';
import moment from 'moment';
import Rodal from '../../../../components/Rodal/Rodal';
import { NotificationFlag } from '../../../../components/NotificationFlag/NotificationFlag';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

const AnnouncementModal = props => {
    const [animation, setAnimation] = useState('slideTop');

    const closePopup = () => {
        props.closeAnnounceMent();
    };

    const getDateInFormat = dateStr => {
        const myMomentObject = moment(dateStr, 'YYYY-MM-DD');

        return myMomentObject.format('MM-DD-YYYY');
    };

    const getTimeInFormat = dateStr => {
        const myMomentObject = moment(dateStr);

        return myMomentObject.format('hh:mm A');
    };

    function createMarkup(desc) {
        return { __html: desc };
    }

    return (
        <div>
            {/* Vet Value Announcements Modal */}
            {props.isVisible ? (
                <Rodal
                    visible={props.isVisible}
                    onClose={() => closePopup()}
                    animation={setAnimation}
                    showMask={true}
                    width={615}
                    showCloseButton={true}>
                    <ModalHeader>VetValue Announcements</ModalHeader>
                    <ModalBody>
                        <div className="vet_value_content">
                            {props.data.length > 0 ? (
                                props.data.map(user => (
                                    <div className="vat_list_wrapper mb-3" key={user.id || user.title} style={{ position: 'relative' }}>
                                        <div className="date_tag">
                                            <span className="d_span">
                                                {getDateInFormat(user.postedOn)}
                                            </span>
                                        </div>
                                        <div className="list-content">
                                            <div className="announcement-title-wrapper">
                                                <Label>
                                                    <b>{user.title}</b>
                                                </Label>
                                                <NotificationFlag
                                                    eventCode={`${NotificationFlagsCategories.AnnouncementsCode}.${user.id}`}
                                                    doNotRemove
                                                />
                                            </div>
                                            <p
                                                dangerouslySetInnerHTML={createMarkup(
                                                    user.description
                                                )}></p>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <>
                                    {' '}
                                    <h6>
                                        <b>No announcement data found</b>
                                    </h6>{' '}
                                </>
                            )}
                        </div>
                    </ModalBody>
                </Rodal>
            ) : (
                ''
            )}

            {/* End Vet Value Announcements Modal */}
        </div>
    );
};

export default AnnouncementModal;
